<script setup lang="ts">
import { useMetaTags } from '@/composables/useMetaTags'

// Enable automatic meta tag updates for all routes
const { enableAutoMetaTags } = useMetaTags()
enableAutoMetaTags()
</script>

<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <router-view />
  </div>
</template>

<style>
#app {
  font-family: 'Outfit', system-ui, sans-serif;
}
</style>
